import { mergeMap, map, filter, take, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { isAuthenticatedSelector } from '@cbridge-packages/auth';
import { queryParamSelector } from '@cbridge-packages/routing';
import { AlertType } from '@cbridge-packages/alert';
import { isUserSettingsReadySelector, userSettingSelector } from '@cbridge-packages/user-settings';
import { TypeParam, FromParam, ToParam } from '../_helpers/alertsFilterParams';
import { AlertsDashboardAction } from '../alertsDashboard.action';
import { ALERTS_POLLING_SETTING_KEY } from '../alertsDashboard.constans';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>
  & IGetSelectorStateType<typeof isAuthenticatedSelector>
  & IGetSelectorStateType<typeof userSettingSelector>;

export const initDashboardAlertsFilterEpic: IEpic<IState> = (action$, state$) => {
  return state$.pipe(
    map((state) => ({
      alertType: queryParamSelector(state, TypeParam.name),
      rangeFrom: queryParamSelector(state, FromParam.name),
      rangeTo: queryParamSelector(state, ToParam.name),
      // Settings arrive right after login; the saved pause must be known before polling is switched on.
      isReady: isAuthenticatedSelector(state) && isUserSettingsReadySelector(state),
      isPollingPaused: userSettingSelector(state, { settingKey: ALERTS_POLLING_SETTING_KEY }) === false,
    })),
    filter(({ alertType, rangeFrom, rangeTo, isReady }) => Boolean(isReady && (alertType || rangeFrom || rangeTo))),
    distinctUntilChanged(),
    take(1),
    mergeMap(({ alertType, rangeFrom, rangeTo, isPollingPaused }) => {
      const actions = [];
      actions.push(AlertsDashboardAction.updateFilter({
        type: alertType as AlertType,
        fromTimestamp: Number(rangeFrom),
        toTimestamp: Number(rangeTo),
      }));
      // Live range: polling is on unless the user paused it last time.
      if (!rangeTo && !isPollingPaused) {
        actions.push(AlertsDashboardAction.setPollingEnabled(true));
      }
      return actions;
    }),
    takeUntil(
      action$.pipe(
        isTypeOf(AlertsDashboardAction.loadAlertList.done, AlertsDashboardAction.loadAlertList.failed),
      ),
    ),
  );
};
